import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconYoutube(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m15.674 4.118.009.044c.219 1.213.325 2.443.317 3.669a20.003 20.003 0 0 1-.327 3.664 2.525 2.525 0 0 1-1.768 1.816c-.506.135-1.495.219-2.885.272a84.145 84.145 0 0 1-2.759.056L8 13.64l-.261-.001a94.644 94.644 0 0 1-2.759-.056c-1.39-.053-2.378-.136-2.888-.273-.85-.233-1.517-.893-1.773-1.805a19.93 19.93 0 0 1-.317-3.668c-.006-1.223.1-2.444.327-3.692a2.525 2.525 0 0 1 1.768-1.816c.506-.135 1.495-.219 2.885-.272a79.493 79.493 0 0 1 2.759-.056L8.002 2l.261.001a94.644 94.644 0 0 1 2.758.052c1.385.048 2.372.124 2.896.253a2.521 2.521 0 0 1 1.759 1.813zm-2.098-.524c-.377-.092-1.321-.164-2.603-.209a86.772 86.772 0 0 0-2.718-.051l-.254-.001-.254.001a92.432 92.432 0 0 0-2.716.056c-1.278.049-2.22.128-2.582.225-.409.116-.725.441-.819.81a18.627 18.627 0 0 0-.296 3.413c-.007 1.15.092 2.299.281 3.367.114.399.428.71.824.819.371.099 1.313.178 2.591.227a81.093 81.093 0 0 0 2.97.057l.254-.001a92.432 92.432 0 0 0 2.716-.056c1.278-.049 2.22-.128 2.582-.225.409-.116.725-.441.819-.81.201-1.115.3-2.246.296-3.386a18.627 18.627 0 0 0-.292-3.407 1.178 1.178 0 0 0-.8-.828zM6.83 10.593a.666.666 0 0 1-.996-.58v-4.36c0-.511.552-.832.996-.58l3.833 2.18a.667.667 0 0 1 0 1.159l-3.833 2.18zm2.155-2.76L7.167 6.799v2.068l1.818-1.034z"
  }));
}
IconYoutube.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconYoutube.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconYoutube as default };
